import { render, staticRenderFns } from "./Remixicons.vue?vue&type=template&id=74fb3213"
import script from "./Remixicons.vue?vue&type=script&lang=js"
export * from "./Remixicons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports